import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import BackButton from '../../components/BackButton';
import { format } from 'date-fns';

const AddCampaign = () => {
  const navigate = useNavigate();
  const location = useLocation(); // To access the passed data

  const initialFormData = {
    CampaignName: '',
    BUId: sessionStorage.getItem("BUId"), // Retrieve BUId from sessionStorage
    CreatedOn: '',
    CampaignId: '' // Add CampaignId to initial form data
  };

  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // If there's campaign data passed through location.state, pre-fill the form
    if (location.state && location.state.userData) {
      const { campaignName, createdOn, buId, campaignId } = location.state.userData;
      // Ensure BUId and CampaignId are taken from location state or sessionStorage if editing
      setFormData({
        BUId: buId || sessionStorage.getItem("BUId"), // Fallback to sessionStorage if BUId is not present
        CampaignName: campaignName,
        CreatedOn: createdOn,
        CampaignId: campaignId || '' // Set CampaignId if it's available, or set an empty string if not
      });
    }
  }, [location.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const handleCustomRedirect = () => {
    navigate('/CampaignList');
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.CampaignName.trim()) {
      newErrors.CampaignName = 'Campaign Name is required';
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form submit triggered');

    const newErrors = validateForm();
    console.log('Validation Errors:', newErrors);

    if (Object.keys(newErrors).length === 0) {
      console.log('Form is valid, submitting...');
      setLoading(true);

      // If it's a new campaign, set the CreatedOn field
      const currentDateTime = format(new Date(), 'dd/MM/yyyy hh:mm a');
      const updatedFormData = { ...formData, CreatedOn: currentDateTime };

      console.log('Submitting form data:', updatedFormData);

      try {
        const url = location.state && location.state.userData
          ? `${process.env.REACT_APP_API_URL}/Mailer/UpdateCampaign`  // Update campaign if editing
          : `${process.env.REACT_APP_API_URL}/Mailer/CreateCampaign`;  // Create campaign if new

        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updatedFormData),
        });

        console.log('API Response:', response);

        const data = await response.json();
        console.log('API Data:', data);

        if (data) {
          alert(`${data.response.result || data.response}`);
          setFormData(initialFormData); // Clear the form data after successful submission
          navigate('/CampaignList'); // Redirect to campaign list after submission
        } else {
          throw new Error(data.message || 'An error occurred');
        }
      } catch (error) {
        console.error('Error:', error);
        alert(error.message || 'An error occurred. Please try again.');
      } finally {
        setLoading(false);
      }
    } else {
      setErrors(newErrors); // Set validation errors if there are any
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="flex justify-end mb-4">
        <BackButton label="Back" onClickRedirect={handleCustomRedirect} />
      </div>

      <div className="max-w-2xl mx-auto">
        <div className="flex justify-between items-center mb-6">
          <h1 className="text-2xl font-bold text-gray-900">{location.state && location.state.userData ? 'EDIT CAMPAIGN' : 'ADD CAMPAIGN'}</h1>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6 bg-white p-8 rounded-lg shadow">
          <div>
            <label htmlFor="CampaignName" className="block text-sm font-medium text-gray-700">
              Campaign Name
            </label>
            <input
              type="text"
              name="CampaignName"
              id="CampaignName"
              value={formData.CampaignName}
              onChange={handleChange}
              className={`mt-1 block w-full rounded-md border ${errors.CampaignName ? 'border-red-300' : 'border-gray-300'} px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500`}
            />
            {errors.CampaignName && (
              <p className="mt-1 text-sm text-red-600">{errors.CampaignName}</p>
            )}
          </div>

          <div className="flex justify-end">
            <button
              type="submit"
              className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg transition-colors disabled:opacity-50"
              disabled={loading}
            >
              {loading ? 'Saving...' : location.state && location.state.userData ? 'UPDATE' : 'CREATE'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCampaign;
